export const Panel = ({ title, children, testId, action }) => (
  <section className="rounded-2xl border border-border bg-card p-5 sm:p-6" data-testid={testId}>
    <div className="flex items-center justify-between gap-3 mb-4">
      <h3 className="font-display text-lg font-bold">{title}</h3>
      {action}
    </div>
    {children}
  </section>
);

export const KV = ({ rows }) => (
  <dl className="grid gap-x-6 gap-y-3 sm:grid-cols-2 text-sm">
    {rows.map(([k, v]) => (
      <div key={k}>
        <dt className="text-xs uppercase tracking-wider text-muted-foreground font-bold">{k}</dt>
        <dd className="font-semibold break-words whitespace-pre-wrap">{v || "-"}</dd>
      </div>
    ))}
  </dl>
);

export const toIsoFromLocal = (v) => (v ? new Date(v).toISOString() : "");
